export const usOnlyPages = [
  'research-library',
  'announcements',
  'other/legal',
  'press-hub',
  'c',
  'samsung',
  'press-highlights',
]
/**
 * Client-side redirects, ordered by priority
 */
export const clientSideRedirects: ClientSideRedirect[] = [
  // Some pages are only available in English
  ...usOnlyPages.map(page => ({
    from: new RegExp(`^https://(?:www\\.)?naturalcycles\\.se/${page}(/.*)?$`),
    to: `https://www.naturalcycles.com/${page}$1`,
  })),
  // .se/shop/... -> .com/shop/... (we don't localize shop item pages)
  {
    from: /^https:\/\/(?:www\.)?naturalcycles\.se\/shop\/(.+)/,
    to: 'https://www.naturalcycles.com/shop/$1',
  },
  // .se/shop -> .com/shop/se
  {
    from: /^https:\/\/(?:www\.)?naturalcycles\.se\/shop/,
    to: 'https://www.naturalcycles.com/shop/se',
  },
  // .se users to .com/sv
  {
    from: /^https:\/\/(?:www\.)?naturalcycles\.se(\/.*)?/,
    to: 'https://www.naturalcycles.com/sv$1',
  },
]

interface ClientSideRedirect {
  from: RegExp
  /**
   * Can include regex groups from the `from` regex
   */
  to: string
}
